export default __webpack_public_path__ + "static/media/iStock-1213470229.b0d56fba.jpg";